import { MutableRefObject } from 'react'
import { mapStyles } from './styles'
import { MapMarker } from '../../icons/map-marker'

export const getLatLongFromAddress = async (address: string | undefined) => {
  const geocoder = new window.google.maps.Geocoder()
  const response = await geocoder.geocode({ address })
  return response?.results[0]?.geometry.location
}

export const createMap = (
  ref: MutableRefObject<HTMLDivElement | null>,
  zoom: number,
  center: google.maps.LatLng | google.maps.LatLngLiteral | undefined | null
) => {
  if (!ref?.current) return null
  return new window.google.maps.Map(ref.current, {
    zoom,
    center,
    styles: mapStyles,
    disableDefaultUI: true,
  })
}

export const createMarker = (map: google.maps.Map, position: google.maps.LatLng | google.maps.LatLngLiteral) => {
  return new google.maps.Marker({
    icon: getSvgMarker(),
    position,
    map,
  })
}

export const createMarkerInfoWindow = (opts: google.maps.InfoWindowOptions) => {
  return new google.maps.InfoWindow(opts)
}

export const panTo = (map: google.maps.Map, latLng: google.maps.LatLng) => {
  map.panTo(latLng)
}

const getSvgMarker = () => {
  const mapMarker = MapMarker({})

  const url = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(mapMarker)}`

  return {
    url,
    scaledSize: new google.maps.Size(40, 40),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(20, 20),
  }
}
